/* eslint-disable max-len */
import { connect } from 'react-redux'
import { getServices } from '../../actions/services'
import { PageServices } from './PageServices.component'

const mapStateToProps = (state) => {
  return {
    sectors: state.app.sectors,
    services: state.services.list,
  }
}

const mapDispatchToProps = (dispatch) => ({
  getServices: () => dispatch(getServices()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PageServices)


// WEBPACK FOOTER //
// ./src/features/PageServices/PageServices.container.js